import { Link } from "react-router-dom";
import { Activity, Zap } from "lucide-react";
import { shortDate } from "../../lib/api";
import { useAuth } from "../../lib/auth";
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from "../ui/tooltip";

export const RecentActivity = ({ items, onChange }) => {
  const { canWrite } = useAuth();
  return (
    <section className="panel" data-testid="recent-activity">
      <div className="flex items-center justify-between px-5 py-3 border-b border-line">
        <h3 className="label-xs flex items-center gap-2"><Activity className="w-3.5 h-3.5 text-brand" /> Recent activity</h3>
        {canWrite && (
          <TooltipProvider><Tooltip><TooltipTrigger asChild>
            <Link to="/app/whop" className="flex items-center gap-1.5 font-mono text-[10px] tracking-wider px-2.5 py-1.5 bg-brand text-black font-bold" data-testid="run-whop-test-link"><Zap className="w-3 h-3" /> RUN A WHOP TEST</Link>
          </TooltipTrigger><TooltipContent className="max-w-xs">Send a test Whop payment and dispute through the real pipeline. Test records are labelled and can be cleared in one click.</TooltipContent></Tooltip></TooltipProvider>
        )}
      </div>
      <ul className="divide-y divide-divider max-h-[460px] overflow-y-auto">
        {items.map((a, i) => (
          <li key={i} className="px-5 py-3" data-testid={`activity-${i}`}>
            <p className="text-sm flex items-start gap-2"><span className={`mt-1.5 w-1.5 h-1.5 rounded-full shrink-0 ${a.action ? "bg-[#FFB800]" : "bg-brand"}`} />{a.title}</p>
            <p className="text-[11px] text-white/45 mt-0.5 pl-3.5">{a.why}</p>
            <p className="font-mono text-[10px] text-white/35 mt-1 pl-3.5">{shortDate(a.at)}{a.ref && ` · ${a.ref}`}
              {a.action && a.link && <Link to={a.link} className="ml-2 text-[#FFB800] hover:underline">{a.action} →</Link>}</p>
          </li>
        ))}
      </ul>
      <Link to="/app/ingestion" className="block px-5 py-2.5 border-t border-line font-mono text-[10px] text-white/40 hover:text-white" data-testid="raw-webhook-log-link">View raw webhook log →</Link>
    </section>
  );
};
